module.exports = __webpack_public_path__ + "static/media/partnership.60ecff99.svg";